(() => {
  const init = () => {
    const root = document.querySelector('.agg-shell-header[data-enable_sticky="true"]');
    if (!root || root.dataset.aggSmartReady) return;
    root.dataset.aggSmartReady = 'true';
    const headers = [...root.querySelectorAll('#header, #mobile-header')];
    const toggle = root.querySelector('[data-show-mobile-menu]');
    const mobileMenu = root.querySelector('.mobile-menu');
    const searchTriggers = [...root.querySelectorAll('[data-show-search-trigger]')];
    const submenuControls = [...root.querySelectorAll('.close-dropdown, .close-sub-dropdown')];
    let active;
    let lastY = Math.max(0, window.scrollY);
    let distance = 0;
    let frame = 0;
    let searchOrigin = null;
    let searchWasVisible = false;
    const mobileSearchPanel = document.querySelector('.mobile-search');

    const show = () => headers.forEach(header => {
      if (header.classList.contains('agg-smart-hidden')) header.classList.remove('agg-smart-hidden');
    });
    const pinned = () =>
      root.contains(document.activeElement) ||
      document.body.classList.contains('mobile-menu--opened') ||
      root.querySelector('.has-dropdown.is-opened, .has-dropdown.show-dropdown, .header-cart.show-mini-cart, [data-show-search-trigger].is-active') ||
      document.querySelector('.mobile-search--visible, .search__lightbox:not(.fancybox-is-closing), .search-overlay.is-opened');

    const update = () => {
      frame = 0;
      const y = Math.max(0, window.scrollY);
      const current = headers.find(header => header.offsetHeight > 0);
      if (current !== active) {
        show();
        active = current;
        distance = 0;
        lastY = y;
      }
      const delta = y - lastY;
      lastY = y;
      if (!active || y <= 100 || !active.parentElement.classList.contains('is-sticky') || pinned()) {
        show();
        distance = 0;
        return;
      }
      if (delta && Math.sign(delta) !== Math.sign(distance)) distance = 0;
      distance += delta;
      if (Math.abs(distance) >= 6) {
        active.classList.toggle('agg-smart-hidden', distance > 0);
        distance = 0;
      }
    };
    const requestUpdate = () => {
      if (!frame) frame = window.requestAnimationFrame(update);
    };
    const sync = () => {
      if (toggle) {
        const opened = toggle.dataset.showMobileMenu === 'true';
        if (opened && window.jQuery) window.jQuery(document.body).data('current-position', Number(document.body.getAttribute('data-current-position')) || 0);
        toggle.setAttribute('aria-expanded', String(opened));
        if (mobileMenu) mobileMenu.inert = !opened;
      }
      root.querySelectorAll('#header .header__menu-items > .has-dropdown').forEach(item => {
        const expanded = String(item.classList.contains('is-opened') || item.classList.contains('show-dropdown'));
        item.setAttribute('aria-expanded', expanded);
        item.querySelector(':scope > label > .header__link')?.setAttribute('aria-expanded', expanded);
      });
      submenuControls.forEach(control => {
        const label = control.closest('label');
        const input = document.getElementById(label.htmlFor);
        if (!input) return;
        control.setAttribute('aria-expanded', String(input.checked));
        const submenu = label.nextElementSibling;
        if (submenu?.classList.contains('mobile-menu__submenu')) submenu.inert = !input.checked;
      });
      requestUpdate();
    };

    if (toggle) {
      toggle.setAttribute('role', 'button');
      toggle.tabIndex = 0;
      toggle.setAttribute('aria-label', root.querySelector('nav')?.getAttribute('aria-label') || 'Navigation');
    }
    searchTriggers.forEach(trigger => {
      trigger.setAttribute('role', 'button');
      trigger.tabIndex = 0;
      trigger.setAttribute('aria-label', trigger.querySelector('.icon-caption')?.textContent.trim() || 'Search');
    });
    root.querySelectorAll('.header-cart > a').forEach(link => {
      link.setAttribute('aria-label', link.querySelector('.icon-caption')?.textContent.trim() || 'Cart');
    });
    submenuControls.forEach(control => {
      const label = control.closest('label');
      control.setAttribute('role', 'button');
      control.tabIndex = 0;
      control.setAttribute('aria-label', label.querySelector('a')?.textContent.trim() || 'Submenu');
    });
    root.querySelectorAll('.submenu__input').forEach(input => { input.tabIndex = -1; });
    root.addEventListener('click', event => {
      if (event.target.closest('#mobile-header [data-show-search-trigger]')) searchOrigin = Math.max(0, window.scrollY);
    }, true);
    root.addEventListener('keydown', event => {
      const control = event.target.closest('[data-show-mobile-menu], [data-show-search-trigger], .close-dropdown, .close-sub-dropdown');
      if (control && (event.key === 'Enter' || event.key === ' ')) {
        event.preventDefault();
        event.stopPropagation();
        control.click();
      }
    });
    document.addEventListener('keydown', event => {
      if (event.key !== 'Escape') return;
      const mobileSearch = document.querySelector('.mobile-search--visible');
      if (mobileSearch) {
        if (window.jQuery) window.jQuery(mobileSearch).stop(true, true);
        mobileSearch.querySelector('.close-search')?.click();
        root.querySelector('#mobile-header [data-show-search-trigger]')?.focus({ preventScroll: true });
        return;
      }
      if (event.defaultPrevented || document.querySelector('.search__lightbox:not(.fancybox-is-closing)') || [...root.querySelectorAll('shopify-account')].some(account => account.shadowRoot?.querySelector('dialog[open]'))) return;
      const opened = root.querySelector('#header .header__menu-items > .has-dropdown:is(.is-opened, .show-dropdown)');
      if (opened) {
        opened.classList.remove('is-opened', 'show-dropdown');
        opened.querySelector('.navbar-dropdown')?.classList.remove('show-nested-dropdown');
        opened.querySelectorAll('input[type="checkbox"]').forEach(input => { input.checked = false; });
        const link = opened.querySelector(':scope > label > .header__link');
        if (link) {
          link.dataset.clicked = 'false';
          link.focus({ preventScroll: true });
        }
        sync();
      } else if (toggle?.dataset.showMobileMenu === 'true') {
        toggle.click();
        toggle.focus({ preventScroll: true });
      }
    }, true);
    if (mobileSearchPanel) new MutationObserver(() => {
      const visible = mobileSearchPanel.classList.contains('mobile-search--visible');
      if (searchWasVisible && !visible && searchOrigin !== null) {
        window.scrollTo(0, searchOrigin);
        searchOrigin = null;
      }
      searchWasVisible = visible;
      requestUpdate();
    }).observe(mobileSearchPanel, { attributes: true, attributeFilter: ['class'] });
    root.addEventListener('change', sync);
    document.addEventListener('focusin', () => {
      if (pinned()) show();
      requestUpdate();
    });
    window.addEventListener('scroll', requestUpdate, { passive: true });
    window.addEventListener('resize', () => {
      show();
      distance = 0;
      lastY = Math.max(0, window.scrollY);
      requestUpdate();
    }, { passive: true });
    new MutationObserver(sync).observe(root, { subtree: true, childList: true, attributes: true, attributeFilter: ['class', 'data-show-mobile-menu'] });
    new MutationObserver(requestUpdate).observe(document.body, { attributes: true, attributeFilter: ['class'] });
    sync();
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init, { once: true });
  else init();
  document.addEventListener('shopify:section:load', init);
})();
